<script>
  import conciliacaoProjetoServico from '../servico';

  export default {
    props: {
      idContaCript: { type: String, required: true },
      dataReferencia: { type: String, default: '' },
      horizonte: { type: Number, default: 1 },
      ateData: { type: String, default: '' },
      podeTratar: { type: Boolean, default: false },
    },
    data() {
      return {
        carregando: true,
        detalhe: null,
        erro: '',
        verExtratos: false,
        verLancamentos: false,
        observacao: '',
        salvando: false,
      };
    },
    computed: {
      conta() { return (this.detalhe && this.detalhe.conta) || {}; },
      temSaldoBanco() { return this.conta.saldoBanco !== null && this.conta.saldoBanco !== undefined && this.conta.dataSaldoBanco > 0; },
      residuoFecha() { return this.detalhe && this.detalhe.residuo !== null && Math.abs(this.detalhe.residuo) < 0.01; },
      totalCompromissos() { return ((this.detalhe && this.detalhe.compromissos) || []).reduce((t, c) => t + (c.valor || 0), 0); },
      totalAplicado() { return ((this.detalhe && this.detalhe.aplicacoes) || []).reduce((t, a) => t + (a.saldo || 0), 0); },
      tipoConta() {
        switch (this.conta.tipoConta) {
          case 2: return 'Poupança';
          case 3: return 'Bloqueio';
          default: return 'Corrente';
        }
      },
      horizonteTexto() {
        if (this.ateData) return 'data escolhida';
        return this.horizonte === 5 ? 'semana' : this.horizonte === -1 ? 'dia' : 'D+' + this.horizonte;
      },
    },
    mounted() {
      this.carregar();
    },
    methods: {
      carregar() {
        this.carregando = true;
        this.erro = '';
        conciliacaoProjetoServico.detalheTesouraria(this.idContaCript, this.dataReferencia, this.horizonte, this.ateData)
          .then(dados => { this.detalhe = dados; this.carregando = false; })
          .catch(res => {
            this.carregando = false;
            this.erro = res && res.body && res.body.message ? res.body.message : 'Não foi possível carregar a conta.';
          });
      },
      moeda(v) {
        const n = v || 0;
        const texto = Math.abs(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return (n < -0.004 ? '−R$ ' : 'R$ ') + texto;
      },
      moedaSinal(v) {
        const n = v || 0;
        if (n > 0.004) return '+' + this.moeda(n);
        return this.moeda(n);
      },
      origemTexto(o) {
        if (o === 'bordero') return 'borderô';
        if (o === 'previsto') return 'previsto';
        if (o === 'atrasado') return 'atrasado';
        if (o === 'transferencia') return 'transferência';
        return 'vencendo';
      },
      origemCls(o) {
        if (o === 'bordero') return 'chip-roxo';
        if (o === 'atrasado') return 'chip-vermelho';
        if (o === 'transferencia') return 'chip-verde';
        if (o === 'previsto') return 'chip-azul';
        return 'chip-ambar';
      },
      marcarTratada() {
        if (this.salvando) return;
        this.salvando = true;
        conciliacaoProjetoServico.tratarTesouraria(this.idContaCript, this.dataReferencia, this.observacao)
          .then(() => {
            this.salvando = false;
            this.observacao = '';
            toastr.success('Conta marcada como tratada.');
            this.$emit('tratada');
            this.carregar();
          })
          .catch(res => {
            this.salvando = false;
            toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível marcar a conta.');
          });
      },
    },
  };
</script>

<template>
  <div class="dr-ov">
    <div class="drawer">
      <div class="dr-head">
        <div v-if="detalhe">
          <div class="dr-tit">{{ conta.nomeConta }}</div>
          <div class="dr-sub">
            <span class="mono">{{ conta.nomeBanco }} · Ag {{ conta.numeroAgencia }} · C/C {{ conta.numeroConta }}</span>
            <span class="chip chip-cinza">{{ tipoConta }}</span>
            <span v-if="conta.encerrada" class="chip chip-vermelho">encerrada</span>
          </div>
          <div class="dr-sub">
            <span>Referência {{ detalhe.diaSemanaReferencia }} {{ detalhe.dataReferencia }}</span>
            <span>· Saldo em {{ detalhe.dataReferencia.substr(0, 5) }} <b class="mono">{{ moeda(conta.saldoCompensado) }}</b> (compensado no Manager)</span>
            <span v-if="conta.fonteSaldo === 'extrato'">· Banco <b class="mono">{{ moeda(conta.saldoBanco) }}</b> (extrato de {{ conta.dataSaldoBancoTexto }})</span>
            <span>· Por operação <b class="mono">{{ moeda(conta.saldoSistema) }}</b></span>
          </div>
        </div>
        <div v-else class="dr-tit">Carregando conta...</div>
      </div>

      <div class="dr-corpo">
        <div v-if="carregando" class="dr-carregando"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
        <div v-else-if="erro" class="dr-erro"><i class="fa fa-exclamation-triangle"></i> {{ erro }}</div>
        <template v-else>

          <div class="bloco">
            <div class="bloco-tit">
              <span>Reconciliação do saldo<template v-if="temSaldoBanco"> em {{ conta.dataSaldoBancoTexto }}</template></span>
              <small>conta de chegar</small>
            </div>
            <div class="bloco-corpo conta-chegar">
              <div v-if="!temSaldoBanco" class="aviso-cinza">
                <i class="fa fa-info-circle"></i>
                O extrato desta conta não informa saldo. A diferença não pode ser calculada; os pendentes abaixo continuam valendo.
              </div>

              <div class="cc-l">
                <span class="op"></span><span class="lbl">Saldo conciliado{{ temSaldoBanco ? ' em ' + conta.dataSaldoBancoTexto : '' }}</span>
                <span class="pontos"></span><span class="val">{{ moeda(temSaldoBanco ? conta.saldoConciliadoNaDataBanco : conta.saldoConciliado) }}</span>
              </div>
              <div class="cc-l">
                <span class="op">+</span>
                <span class="lbl">
                  Movimentos do extrato ainda não conciliados ({{ conta.extratosPendentes }})
                  <button v-if="detalhe.extratosPendentes.length" type="button" class="exp" @click="verExtratos = !verExtratos">
                    <i class="fa" :class="verExtratos ? 'fa-angle-down' : 'fa-angle-right'"></i> {{ verExtratos ? 'Ocultar' : 'Ver itens' }}
                  </button>
                </span>
                <span class="pontos"></span><span class="val">{{ moedaSinal(conta.valorExtratosPendentes) }}</span>
              </div>
              <div v-if="verExtratos" class="cc-sub">
                <div v-for="(m, i) in detalhe.extratosPendentes" :key="'e' + i">
                  <span class="mono">{{ m.dataTexto }}</span><span class="hist">{{ m.historico }}</span><span class="val">{{ moedaSinal(m.valor) }}</span>
                </div>
              </div>
              <template v-if="temSaldoBanco">
                <div class="cc-l total">
                  <span class="op">=</span><span class="lbl">Saldo esperado do banco</span>
                  <span class="pontos"></span><span class="val">{{ moeda(detalhe.saldoEsperadoBanco) }}</span>
                </div>
                <div class="cc-l">
                  <span class="op"></span><span class="lbl">Saldo do banco (extrato de {{ conta.dataSaldoBancoTexto }})</span>
                  <span class="pontos"></span><span class="val">{{ moeda(conta.saldoBanco) }}</span>
                </div>
                <div class="cc-l res">
                  <span class="op"></span><span class="lbl">Resíduo não explicado</span>
                  <span class="pontos"></span>
                  <span class="val val-res">
                    <span class="chip" :class="residuoFecha ? 'chip-verde' : 'chip-vermelho'">{{ residuoFecha ? 'fecha' : 'resíduo a investigar' }}</span>
                    <span :class="residuoFecha ? 'ok' : 'neg'">{{ moedaSinal(detalhe.residuo) }}</span>
                  </span>
                </div>
              </template>

              <div class="cc-info">
                <div class="cc-l">
                  <span class="op"></span>
                  <span class="lbl">
                    Lançamentos do sistema ainda não conferidos até {{ detalhe.dataReferencia.substr(0, 5) }} ({{ conta.lancamentosPendentes }})
                    <button v-if="detalhe.lancamentosPendentes.length" type="button" class="exp" @click="verLancamentos = !verLancamentos">
                      <i class="fa" :class="verLancamentos ? 'fa-angle-down' : 'fa-angle-right'"></i> {{ verLancamentos ? 'Ocultar' : 'Ver itens' }}
                    </button>
                  </span>
                  <span class="pontos"></span><span class="val">{{ moedaSinal(conta.valorLancamentosPendentes) }}</span>
                </div>
                <div v-if="verLancamentos" class="cc-sub">
                  <div v-for="(m, i) in detalhe.lancamentosPendentes" :key="'l' + i">
                    <span class="mono">{{ m.dataTexto }}</span><span class="hist">{{ m.historico }}</span><span class="val">{{ moedaSinal(m.valor) }}</span>
                  </div>
                </div>
                <div v-if="conta.lancamentosPendentesAntigos" class="cc-l cc-antigos">
                  <span class="op"></span>
                  <span class="lbl">
                    <i class="fa fa-info-circle"></i>
                    Antes da data de corte da conciliação ({{ detalhe.dataCorte }}), sem conferência, já contados no saldo pela data do lançamento ({{ conta.lancamentosPendentesAntigos }})
                  </span>
                  <span class="pontos"></span><span class="val">{{ moedaSinal(conta.valorLancamentosPendentesAntigos) }}</span>
                </div>
                <div class="cc-nota">O saldo usa a data do lançamento antes da data de corte da conciliação e a data de compensação a partir dela. Os pendentes são tratados na Conciliação de Banco.</div>
              </div>
            </div>
          </div>

          <div class="bloco">
            <div class="bloco-tit">
              <span>Compromissos até {{ detalhe.diaSemanaLimite }} {{ detalhe.limite }}</span>
              <small>{{ horizonteTexto }}</small>
            </div>
            <div class="bloco-corpo">
              <div v-if="!detalhe.compromissos.length" class="vazio"><i class="fa fa-check"></i> Nenhum título previsto, em borderô ou vencendo até {{ detalhe.limite }} para esta conta.</div>
              <table v-else class="tab-mini">
                <thead>
                  <tr>
                    <th>Fornecedor</th><th class="r">Valor</th><th>Venc.</th><th>Previsão</th><th>Borderô</th><th>Forma</th><th>Origem</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="c in detalhe.compromissos" :key="c.idLancamento">
                    <td class="forn" :title="c.fornecedor">{{ c.fornecedor }}</td>
                    <td class="r mono">{{ moeda(c.valor) }}</td>
                    <td class="mono">{{ c.vencimento }}</td>
                    <td class="mono">{{ c.previsao || '—' }}</td>
                    <td>
                      <template v-if="c.numeroBordero">
                        <span class="mono">{{ c.numeroBordero }}</span>
                        <span class="chip chip-lc" :class="c.arquivoGerado > 1 ? 'chip-verde' : 'chip-cinza'">{{ c.arquivoGerado > 1 ? 'arquivo enviado ' + c.arquivoGeradoTexto : 'aberto' }}</span>
                      </template>
                      <span v-else class="mudo">—</span>
                    </td>
                    <td>{{ c.forma || '—' }}</td>
                    <td><span class="chip chip-lc" :class="origemCls(c.origem)">{{ origemTexto(c.origem) }}</span></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr><td>{{ detalhe.compromissos.length }} título(s)</td><td class="r mono">{{ moeda(totalCompromissos) }}</td><td colspan="5"></td></tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div class="bloco">
            <div class="bloco-tit"><span>Aplicações ativas</span><small v-if="detalhe.aplicacoes.length">{{ moeda(totalAplicado) }} aplicado</small></div>
            <div class="bloco-corpo">
              <div v-if="!detalhe.aplicacoes.length" class="vazio"><i class="fa fa-info-circle"></i> Nenhuma aplicação ativa nesta conta.</div>
              <div v-else class="apl-grid">
                <div v-for="a in detalhe.aplicacoes" :key="a.idAplicacao" class="apl-card">
                  <div class="apl-nome">{{ a.nomeTipoAplicacao }}</div>
                  <div class="apl-saldo mono">{{ moeda(a.saldo) }}</div>
                  <div class="apl-obs" v-if="a.ultimaOperacao">{{ a.ultimaOperacao }}</div>
                  <div class="chips">
                    <span v-if="a.resgateAutomatico" class="chip chip-azul chip-lc">resgate automático</span>
                    <span v-if="a.poupanca" class="chip chip-cinza chip-lc">poupança</span>
                    <span v-if="a.diasParada > 0" class="chip chip-ambar chip-lc">parada há {{ a.diasParada }} dias</span>
                    <span v-if="a.nomeProjeto" class="chip chip-cinza chip-lc" :title="a.nomeProjeto">{{ a.nomeProjeto }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="bloco">
            <div class="bloco-tit"><span>Extrato</span><small>última linha e arquivos recebidos</small></div>
            <div class="bloco-corpo">
              <div v-if="!detalhe.ultimaLinhaExtrato" class="vazio"><i class="fa fa-info-circle"></i> Nenhuma linha de extrato recebida para esta conta.</div>
              <div v-else class="ext-linha">
                <span class="mono">{{ detalhe.ultimaLinhaExtrato.dataTexto }}</span>
                <span class="hist">{{ detalhe.ultimaLinhaExtrato.historico }}</span>
                <span class="mono r" :class="detalhe.ultimaLinhaExtrato.valor < 0 ? 'neg' : ''">{{ moedaSinal(detalhe.ultimaLinhaExtrato.valor) }}</span>
                <span class="mono r">{{ detalhe.ultimaLinhaExtrato.saldoApos !== null ? 'saldo ' + moeda(detalhe.ultimaLinhaExtrato.saldoApos) : 'sem saldo' }}</span>
              </div>
              <div v-if="detalhe.arquivos.length" class="ext-arqs">
                <div v-for="(a, i) in detalhe.arquivos" :key="'a' + i" class="ext-arq">
                  <i class="fa fa-file-text-o"></i><span class="hist">{{ a.nomeArquivo }}</span><span>processado em {{ a.dataProcessamento }}</span><span class="mono r">{{ a.qtdeLinhas }} linhas</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="detalhe.ocorrencias.length" class="bloco">
            <div class="bloco-tit"><span>Tratativas</span><small>últimas 5</small></div>
            <div class="bloco-corpo">
              <div v-for="(o, i) in detalhe.ocorrencias" :key="'o' + i" class="oc-linha">
                <span class="mono">{{ o.dataHora }}</span>
                <span class="oc-usu">{{ o.usuario }}</span>
                <span class="hist">{{ o.observacao || 'sem observação' }}</span>
                <span class="mudo">ref. {{ o.dataReferencia }}</span>
              </div>
            </div>
          </div>

        </template>
      </div>

      <div class="dr-foot">
        <template v-if="podeTratar && detalhe">
          <input type="text" class="form-control dr-obs" v-model="observacao" maxlength="1000" placeholder="Observação: o que foi verificado nesta conta">
          <button type="button" class="btn btn-default" :disabled="salvando" @click="marcarTratada">
            <i class="fa" :class="salvando ? 'fa-spinner fa-pulse' : 'fa-check'"></i> Marcar como tratada
          </button>
        </template>
        <span v-else class="dr-foot-esp"></span>
        <button type="button" class="btn rd-sair" @click="$emit('fechar')"><i class="fa fa-times"></i> Fechar</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .dr-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.42); z-index: 2000; }
  .drawer { position: absolute; top: 0; right: 0; bottom: 0; width: 760px; max-width: 96vw; background: #fff; box-shadow: -12px 0 40px rgba(16,24,40,.32); display: flex; flex-direction: column; }
  .dr-head { flex: 0 0 auto; padding: 14px 20px 12px; border-bottom: 1px solid #eceef1; }
  .dr-tit { font-size: 15px; font-weight: 600; color: #1c2024; }
  .dr-sub { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; margin-top: 4px; font-size: 12px; color: #6b747e; }
  .dr-sub .mono, .dr-sub b { color: #34495e; }
  .dr-corpo { flex: 1 1 auto; min-height: 0; overflow: auto; padding: 14px 20px; display: flex; flex-direction: column; gap: 12px; background: #f7f9fa; }
  .dr-carregando { text-align: center; padding: 40px; color: #8a939c; }
  .dr-erro { padding: 14px; border: 1px solid #f5c6c6; background: #fdecec; color: #a13c3c; border-radius: 6px; }
  .dr-foot { flex: 0 0 auto; display: flex; align-items: center; gap: 10px; padding: 12px 20px; border-top: 1px solid #dfe3e8; background: #f7f9fa; }
  .dr-obs { flex: 1 1 auto; }
  .dr-foot-esp { flex: 1 1 auto; }
  .rd-sair { background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; }
  .rd-sair:hover { background: #fbe7e7; border-color: #d9c2c2; color: #a13c3c; }

  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; }
  .r { text-align: right; }
  .ok { color: #0a6d4d; font-weight: 600; }
  .neg { color: #c0392b; font-weight: 600; }
  .mudo { color: #b3b9c0; }

  .bloco { background: #fff; border: 1px solid #e6e9ed; border-radius: 7px; }
  .bloco-tit { display: flex; justify-content: space-between; align-items: center; padding: 9px 14px; border-bottom: 1px solid #eef1f4; font-size: 12.5px; font-weight: 600; color: #1c2024; }
  .bloco-tit small { font-weight: 400; color: #8a939c; font-size: 11.5px; }
  .bloco-corpo { padding: 10px 14px; }

  .aviso-cinza { margin-bottom: 8px; padding: 8px 10px; border-radius: 5px; background: #eef3f8; border: 1px solid #cfdbe7; color: #4f6b86; font-size: 12px; }
  .conta-chegar { display: flex; flex-direction: column; }
  .cc-l { display: flex; align-items: center; gap: 8px; padding: 5px 0; font-size: 12.5px; color: #34495e; }
  .cc-l .op { width: 14px; text-align: center; color: #8a939c; font-family: 'IBM Plex Mono', Consolas, monospace; }
  .cc-l .lbl { display: flex; align-items: center; gap: 6px; }
  .cc-l .pontos { flex: 1 1 auto; border-bottom: 1px dotted #d3d8de; height: 1px; margin: 0 6px; min-width: 20px; }
  .cc-l .val { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; white-space: nowrap; text-align: right; min-width: 140px; }
  .cc-l .val-res { display: inline-flex; align-items: center; justify-content: flex-end; gap: 8px; }
  .cc-l.total { border-top: 1px solid #dfe3e8; margin-top: 3px; padding-top: 8px; font-weight: 600; color: #1c2024; }
  .exp { display: inline-flex; align-items: center; justify-content: center; gap: 6px; height: 28px; padding: 0 12px; margin-left: 6px; background: #fff; border: 1px solid #c7cdd4; border-radius: 5px; color: #12876f; font-size: 12px; font-weight: 600; cursor: pointer; white-space: nowrap; }
  .exp:hover { background: #f2fbf8; border-color: #1ab394; }
  .cc-sub { margin: 2px 0 6px 22px; border: 1px solid #eef1f4; border-radius: 5px; background: #fbfcfd; max-height: 220px; overflow: auto; }
  .cc-sub > div { display: grid; grid-template-columns: 78px minmax(0, 1fr) 130px; gap: 8px; padding: 4px 10px; font-size: 11.5px; color: #5b6570; border-top: 1px solid #f0f1f3; }
  .cc-sub > div:first-child { border-top: none; }
  .cc-sub .val { text-align: right; font-family: 'IBM Plex Mono', Consolas, monospace; color: #34495e; }
  .hist { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .cc-info { margin-top: 10px; padding-top: 8px; border-top: 1px dashed #dfe3e8; }
  .cc-info .cc-l { color: #6b747e; }
  .cc-nota { font-size: 11.5px; color: #8a939c; margin-top: 2px; }
  .cc-antigos .fa { color: #b3b9c0; }
  .cc-alerta { color: #8a5a00 !important; background: #fdf6e7; border-radius: 4px; padding-left: 4px; padding-right: 4px; }
  .cc-alerta .fa { color: #c98a00; }

  .vazio { display: flex; align-items: center; gap: 8px; padding: 8px 2px; color: #8a939c; font-size: 12.5px; }
  .vazio .fa-check { color: #1ab394; }
  .tab-mini { width: 100%; border-collapse: collapse; }
  .tab-mini th { font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; text-align: left; padding: 4px 6px; border-bottom: 1px solid #dfe3e8; white-space: nowrap; }
  .tab-mini th.r { text-align: right; }
  .tab-mini td { font-size: 12px; color: #34495e; padding: 6px; border-top: 1px solid #f0f1f3; vertical-align: middle; white-space: nowrap; }
  .tab-mini td.forn { max-width: 190px; overflow: hidden; text-overflow: ellipsis; }
  .tab-mini tfoot td { font-weight: 600; color: #1c2024; border-top: 2px solid #dfe3e8; background: #f7f9fa; }

  .apl-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
  .apl-card { border: 1px solid #e6e9ed; border-radius: 6px; padding: 9px 12px; background: #fbfcfd; display: flex; flex-direction: column; gap: 4px; min-width: 0; }
  .apl-nome { font-size: 12.5px; font-weight: 600; color: #1c2024; }
  .apl-saldo { font-size: 16px; font-weight: 600; color: #1c2024; }
  .apl-obs { font-size: 11.5px; color: #6b747e; }
  .chips { display: flex; flex-wrap: wrap; gap: 4px; }

  .ext-linha { display: grid; grid-template-columns: 78px minmax(0, 1fr) 120px 150px; gap: 8px; align-items: center; font-size: 12px; color: #34495e; padding: 6px 8px; background: #fbfcfd; border: 1px solid #eef1f4; border-radius: 5px; }
  .ext-arqs { margin-top: 8px; display: flex; flex-direction: column; gap: 3px; }
  .ext-arq { display: grid; grid-template-columns: 16px minmax(0, 1fr) 170px 80px; gap: 8px; align-items: center; font-size: 11.5px; color: #5b6570; padding: 3px 4px; }
  .oc-linha { display: grid; grid-template-columns: 110px 140px minmax(0, 1fr) 100px; gap: 8px; font-size: 12px; color: #34495e; padding: 4px 0; border-top: 1px solid #f0f1f3; }
  .oc-linha:first-child { border-top: none; }
  .oc-usu { font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

  .chip { display: inline-flex; align-items: center; gap: 4px; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; border-radius: 10px; padding: 1px 7px; line-height: 15px; white-space: nowrap; border: 1px solid transparent; max-width: 100%; overflow: hidden; text-overflow: ellipsis; }
  .chip-lc { text-transform: none; letter-spacing: 0; font-weight: 600; font-size: 10.5px; }
  .chip-cinza { color: #5b6570; background: #f1f3f5; border-color: #dfe3e8; }
  .chip-vermelho { color: #a13c3c; background: #fdecec; border-color: #f5c6c6; }
  .chip-roxo { color: #5b3a9e; background: #f1ecfa; border-color: #d9cdf0; }
  .chip-ambar { color: #8a5a00; background: #fdf3e0; border-color: #f0d9a8; }
  .chip-azul { color: #2b5b8c; background: #e8f1fb; border-color: #c2d8ef; }
  .chip-verde { color: #0a6d4d; background: #e5f7f0; border-color: #b8e4d2; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/PosicaoTesourariaDetalhe.vue